import { render, staticRenderFns } from "./AboutUsEn.vue?vue&type=template&id=370ed72a&"
import script from "./AboutUsEn.vue?vue&type=script&lang=js&"
export * from "./AboutUsEn.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsEn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports